import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FancyPhonePipe, FormatPhoneNumberPipe, FormatPhonePipe} from './format-phone.pipe';
import {EnumDisplayPipe} from './enum-display.pipe';
import {FilterDoctorPipe} from './filter-doctor.pipe';
import {FilterPatientPipe} from './filter-patient.pipe';
import {KeysPipe} from './keys.pipe';
import {FilterNotePipe} from './filter-note.pipe';
import {FilterNoteGroupPipe} from './filter-note-group.pipe';
import {FilterProcedurePipe} from './filter-procedure.pipe';
import {CapitalizePipe} from './string.pipe';
import { ItemFilterPipe } from './item-filter.pipe';
import { SecureImagePipe } from './secure-image.pipe';

@NgModule({
  declarations: [
    FormatPhoneNumberPipe,
    FormatPhonePipe,
    FancyPhonePipe,
    EnumDisplayPipe,
    FilterDoctorPipe,
    FilterPatientPipe,
    KeysPipe,
    FilterNotePipe,
    FilterNoteGroupPipe,
    FilterProcedurePipe,
    ItemFilterPipe,
    CapitalizePipe,
    SecureImagePipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    FormatPhoneNumberPipe,
    FormatPhonePipe,
    FancyPhonePipe,
    EnumDisplayPipe,
    FilterDoctorPipe,
    FilterPatientPipe,
    KeysPipe,
    FilterNotePipe,
    FilterNoteGroupPipe,
    FilterProcedurePipe,
    ItemFilterPipe,
    CapitalizePipe,
    SecureImagePipe
  ]
})
export class PipeModule {
}
